import { useTranslation } from "react-i18next";

export const useTranslations = () => {
    const { t } = useTranslation();
    return {
        Signout: t("Signout"),
        Welcome: t("Welcome"),
        Loggedinas: t("Logged in as"),
        MedlineHealth: t("Medline Health"),
        Sessiontimedout: t('Uh-oh! Your session has timed out'),
        Sessiontoolong: t("It seems you took a bit too long."),
        SessionRefresh: t("Refresh the page to continue working or you will be logged out in"),
        SessionSeconds: t("seconds."),
        Refresh: t("Refresh"),
        Edit: t("Edit"),
        Selectaprovider: t("Select a provider"),
        ChangeProvider: t("Change Provider"),
        Menu: t("Menu"),
        Home: t("Home"),
        Providers: t("Providers"),
        SystemUsers: t("System Users"),
        PatientsGroup: t("Patients Group"),
        Threshold: t("Threshold"),
        ScheduleNotifications: t("Schedule Notifications"),
        Survey: t("Survey"),
        ReviewSurvey: t("Review Survey"),
        Patients: t("Patients"),
        Users: t("Users"),
        Members: t("Members"),
        ContactUs: t("Contact Us"),
        BillingReport: t("Billing Report"),
        HangfireDashboard: t("Hangfire Dashboard"),
        FileManager: t("File Manager"),
    };
};